import React, { useState, useEffect } from 'react'
import './Profile.css'
import { Header } from '../../components/Header/Header'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { Link, useNavigate } from 'react-router-dom'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import icon from '../../assets/images/i.png'

export const Profile = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }

  const [data, setData] = useState()
  const [showPassword, setShowPassword] = useState(false)
  const [passwordError, setPasswordErr] = useState('')
  const [phone, setPhone] = useState('')
  const role = localStorage.getItem('role')
  const token = localStorage.getItem('token')
  const id = localStorage.getItem('id')

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  // get details of logged in user
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'enduser/fetchProfile',

        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setData(res.data.data[0])
        setPhone(res.data.data[0].contact)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // update details of logged in user
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'enduser/updateProfile',

        {
          id: id,
          name: data.name,
          contact: phone,
          password: data.password,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        })
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // password validation
  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim()
    const passwordInputFieldName = evnt.target.name
    //for password
    if (passwordInputFieldName === 'password') {
      const uppercaseRegExp = /(?=.*?[A-Z])/
      const lowercaseRegExp = /(?=.*?[a-z])/
      const digitsRegExp = /(?=.*?[0-9])/
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/
      const minLengthRegExp = /.{8,}/
      const passwordLength = passwordInputValue.length
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue)
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue)
      const digitsPassword = digitsRegExp.test(passwordInputValue)
      const specialCharPassword = specialCharRegExp.test(passwordInputValue)
      const minLengthPassword = minLengthRegExp.test(passwordInputValue)
      let errMsg = ''
      if (passwordLength === 0) {
        errMsg = ''
      } else if (!uppercasePassword) {
        errMsg = 'At least one Uppercase'
      } else if (!lowercasePassword) {
        errMsg = 'At least one Lowercase'
      } else if (!digitsPassword) {
        errMsg = 'At least one digit'
      } else if (!specialCharPassword) {
        errMsg = 'At least one Special Characters'
      } else if (!minLengthPassword) {
        errMsg = 'At least minumum 8 characters'
      } else {
        errMsg = ''
      }
      setPasswordErr(errMsg)
    }
  }

  // to hide/show password
  const onMouseDown = () => {
    setShowPassword(!showPassword)
  }

  return (
    <>
      {role === 'HR' || role === 'Admin' ? <Sidebar /> : <Header />}

      {data ? (
        <>
          <div className="container profile d-flex justify-content-center align-items-center">
            <div className=" mt-5 mb-4">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link
                      to={
                        role === 'HR' || role === 'Admin'
                          ? '/home'
                          : '/interviewerDashboard'
                      }
                      className="link text-primary"
                    >
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Profile
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex justify-content-center w-100">
              <div
                className="card rounded overflow-hidden border border-0 profileCard col-md-3"
                style={{ marginRight: '1rem', height: '308px' }}
              >
                <div
                  style={{
                    backgroundColor: '#275F8E',
                    width: '100%',
                    height: '150px',
                    position: 'absolute',
                  }}
                ></div>
                <div
                  className="d-flex justify-content-center  position-relative mb-2"
                  style={{ marginTop: '25%' }}
                >
                  <img
                    src={icon}
                    className="img-fluid mb-3"
                    alt="..."
                    style={{
                      border: '2px solid white',
                      borderRadius: '50%',
                      width: '120px',
                      height: '120px',
                    }}
                  />
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="row d-flex justify-content-center mb-2">
                    <div className="col-md-8 d-flex justify-content-center">
                      <h6>{data.name}</h6>
                    </div>
                    <div className="col-md-8 d-flex justify-content-center">
                      <h6 className="text-muted">{data.email}</h6>
                    </div>
                    <div className="col-md-8 d-flex justify-content-center ">
                      <h6 className="text-muted">{data.role}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <form onSubmit={postData}>
                <div
                  className="card profileCard  border border-0"
                  style={{ width: '30rem' }}
                >
                  <div className="row mt-2 mb-3">
                    {role === 'HR' || role === 'Admin' ? (
                      <Link
                        to="/home"
                        className="link d-flex justify-content-end"
                      >
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          style={{ marginRight: '2rem', marginTop: '0.5rem' }}
                        ></button>
                      </Link>
                    ) : (
                      <Link
                        to="/InterviewerDashboard"
                        className="link d-flex justify-content-end"
                      >
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          style={{ marginRight: '2rem', marginTop: '0.5rem' }}
                        ></button>
                      </Link>
                    )}
                  </div>
                  <div className="row" style={{ marginLeft: '1.5rem' }}>
                    <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                      Edit profile
                    </h6>
                    <div className="row">
                      <div className="row mt-2">
                        <div className="col-sm-3">
                          <h6 className="mb-0 mt-2">Name</h6>
                        </div>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            defaultValue={data.name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-3">
                          <h6 className="mb-0 mt-2">Contact</h6>
                        </div>
                        <div className="col-sm-9">
                          <PhoneInput
                            country={'in'}
                            value={phone}
                            onChange={setPhone}
                            enableSearch
                            // inputStyle={{ width: '25rem' }}
                            inputClass="form-control w-100"
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-3">
                          <h6 className="mb-0 mt-2">Password</h6>
                        </div>
                        <div className="col-sm-9">
                          <div className="input-group mb-1">
                            <input
                              type={showPassword ? 'text' : 'password'}
                              className="col-md-8 form-control"
                              name="password"
                              defaultValue={data.password}
                              onChange={handleChange}
                              onKeyUp={handleValidation}
                            />
                            <span
                              className="input-group-text"
                              id="basic-addon2"
                              style={{ cursor: 'pointer' }}
                              onMouseDown={onMouseDown}
                              onMouseUp={onMouseDown}
                            >
                              {showPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </span>
                          </div>
                          {passwordError ? (
                            <h6 className="text-danger">{passwordError}</h6>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                      <div className="mb-3 mt-3">
                        {passwordError ? (
                          <button
                            className="btn btn-primary disabled"
                            type="submit"
                          >
                            Update Profile
                          </button>
                        ) : (
                          <button className="btn btn-primary" type="submit">
                            Update Profile
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  )
}
